// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const getCategories = async (language_code = "en") => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getCategories/${language_code}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => json)
    .catch((error) => {
      console.log(error);
    });
};

export { getCategories };
